export default "__VITE_ASSET__b36d562a__"